import { t } from 'ember-intl'
import type { TOC } from '@ember/component/template-only'

export const KidsSafe: TOC<unknown> = <template>
  <a
    href="https://www.kidsafeseal.com/certifiedproducts/Readingeggs_websites.html"
    target="_blank"
    rel="noopener noreferrer"
    title={{t "components.footerMain.imageLinks.kidsafe"}}
  >
    <img
      border="0"
      width="90"
      src="https://www.kidsafeseal.com/sealimage/11640771161720557607/Readingeggs_websites_svg_whitetm.svg"
      alt={{t "components.footerMain.imageLinks.kidsafe"}}
    />
  </a>
</template>

export default KidsSafe
